import _has from 'lodash/has';
import _get from 'lodash/get';

const pickFrom = (obj, path, altPath) => {
  if (_has(obj, path)) return _get(obj, path);
  return altPath ? pickFrom(obj, altPath) : undefined;
};

export default pickFrom;
